export default {
    "getProducts": "b3d5f5460fb42ec08d12225c3ed457d90c134305677b9a19be9262c90d18b423",
    "getCategoryProducts": "455c53870ca853aded0f53d8a06855ca7f7bca9c3676727c4c5104fd8dc1c28b",
    "getProductsOfTheWeek": "f3b98a9d39bd2621bcb0329c88628bd8daf2dafe1d839f28349ba8d756fe3324",
    "getRecommendedProducts": "e7d42acc05f7386d66901a9634815968b3bc21ca6b93fcded73ee3218e3d3203",
    "getProductsOnSale": "9659f7e3426b249ac510bc0fe00499c64632f6855ccbfdc4d0d17f132316302e",
    "getBestsellerProducts": "ccb04e414971a443715ce938384619801705dfdd26c7275ff1b1db487e7f43af"
};
